import { useCallback } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';

export const usePlayNext = () => {
  const player = usePlayer();

  const playNext = useCallback(
    (...args: Parameters<typeof player.playNext>) => {
      const [asset, data] = args;

      player.playNext(
        // passing vendor manually is required to fix tracking for mixed vendors, e.g. playing
        // assets from brandstudio newsroom using player initialized with vgtv provider
        typeof asset === 'number'
          ? asset
          : { ...asset, vendor: asset.provider },
        data
      );
    },
    [player]
  );

  return { playNext };
};
